import React from 'react'; 
import styled from 'styled-components';
import {colours, heights} from '../Styles';
 
function SquareBooking() {
  const {accent} = colours;
  const {headerHeight} = heights;
const SquareBooking = styled.div`
  height: 100vh;
  width: 100vw;
  overflowX: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  margin-top: 20px;
  iframe {
    height: 100%;
    width: 90%;
    border: none;
    box-shadow: 2px 2px 5px rgba(0,0,0,0.2);
  }
  .loading {
    position: absolute;
    transform: translateY(-${headerHeight});
    z-index: -1;
    svg {
      width: 50px;
      height: 50px;
      fill: ${accent};
      animation: spin 1s infinite linear;
    }
  }
  @keyframes spin {
    to {transform: rotate(360deg);}
  }
`;

return (<SquareBooking>
  <div className="loading"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path d="M0 11c.511-6.158 5.685-11 12-11s11.489 4.842 12 11h-2.009c-.506-5.046-4.793-9-9.991-9s-9.485 3.954-9.991 9h-2.009zm21.991 2c-.506 5.046-4.793 9-9.991 9s-9.485-3.954-9.991-9h-2.009c.511 6.158 5.685 11 12 11s11.489-4.842 12-11h-2.009z"/></svg></div>
  <iframe src="https://squareup.com/appointments/buyer/widget/z8l6g3gv6zvfrm/KA0E66NCFA92T" title="square booking"></iframe>
</SquareBooking>)
}

export default SquareBooking;